import * as CubiqTS from "shared/cubiq-model-multi-asset";

export const CHANNEL_ORDER_XFER_SERVICE: string = "OrderXferServiceChannel";

export interface IOrderXferService {
  requestXfer(
    ids: Array<string>,
    comment: string,
    xferAction: CubiqTS.XferAction,
    targetGroupId: string,
    benchmarkXfer?: boolean,
  ): Promise<boolean>;
}
